import React from "react";

// Material UI
import SvgIcon from "@material-ui/core/SvgIcon";

const LayerTypeLineIcon = props => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20">
      <path
        d="M2 11L2.5 11.07L6.07 7C5.89 6.35 6.06 5.61 6.59 5.09C7.37 4.3 8.63 4.3 9.41 5.09C9.94 5.61 10.11 6.35 9.93 7L12.5 9.57L13 9.5C13.18 9.5 13.35 9.5 13.5 9.57L16.07 6.5C16 6.35 16 6.18 16 6C16 5.46957 16.2107 4.96086 16.5858 4.58579C16.9609 4.21071 17.4696 4 18 4C18.5304 4 19.0391 4.21071 19.4142 4.58579C19.7893 4.96086 20 5.46957 20 6C20 6.53043 19.7893 7.03914 19.4142 7.41421C19.0391 7.78929 18.5304 8 18 8C17.82 8 17.65 8 17.5 7.93L14.93 11C15 11.15 15 11.32 15 11.5C15 12.0304 14.7893 12.5391 14.4142 12.9142C14.0391 13.2893 13.5304 13.5 13 13.5C12.4696 13.5 11.9609 13.2893 11.5858 12.9142C11.2107 12.5391 11 12.0304 11 11.5L11.07 11L8.5 8.43C8.18 8.5 7.82 8.5 7.5 8.43L3.93 12.5L4 13C4 13.5304 3.78929 14.0391 3.41421 14.4142C3.03914 14.7893 2.53043 15 2 15C1.46957 15 0.960859 14.7893 0.585786 14.4142C0.210714 14.0391 0 13.5304 0 13C0 12.4696 0.210714 11.9609 0.585786 11.5858C0.960859 11.2107 1.46957 11 2 11Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default LayerTypeLineIcon;
